// extracted by mini-css-extract-plugin
export default {"enter":"error-anim__enter___AGP76","enterActive":"error-anim__enterActive___NGHgT","exit":"error-anim__exit___BeM07","exitActive":"error-anim__exitActive___8Oylp"};